import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";
function Instrument_Check_table({handleClose}) {
  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  const data = [
    {
      date: "01 JAN 2025",
      instrumentId: "TC TL/ BC-01",
      instrumentName: "Ika Bomb Calorimeter",
      checks: [
        "Water Level",
        "Ignition Wise",
        "Chiller Unit",
        "Oxygen Pressure",
        "Electrical Wires",
      ],
      from: "No Break",
      to: "No Break",
      nextDue: "1 MAR 2025",
      type: "Internal",
      checkBy: "Rahul Mali",
      remarks: "Type Here Remark...",
    },
  ];

     const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th  rowSpan="2">Date</th>
                  <th  rowSpan="2">Instrument ID</th>
                  <th  rowSpan="2">Instrument Name</th>
                  <th rowSpan="2">Maintenance Check Points</th>
                  <th colSpan="2" className="text-center">
                    Break Down
                  </th>

                  <th  rowSpan="2">Next Due On</th>
                  <th  rowSpan="2">Internal / External</th>
                  <th  rowSpan="2">Check By</th>
                  <th  rowSpan="2"> Remarks</th>
                </tr>

                <tr>
                  <th>From</th>
                  <th>To</th>
                </tr>
              </thead>

              <tbody>
                {data.map((row, index) => (
                  <tr key={index}>
                    <td>{row.date}</td>
                    <td>{row.instrumentId}</td>
                    <td>{row.instrumentName}</td>

                    <td>
                      <ul className="check_point_list">
                        {row.checks.map((c, i) => (
                          <li key={i}>{c}</li>
                        ))}
                      </ul>

                      <div className="add_another_holder">
                        <div className="note_text_holder">
                          <p className="red_text">
                            <FontAwesomeIcon icon={faCirclePlus} /> Add Another
                            Document
                          </p>
                        </div>
                      </div>
                    </td>

                    <td>{row.from}</td>
                    <td>{row.to}</td>
                    <td>{row.nextDue}</td>
                    <td>{row.type}</td>
                    <td>{row.checkBy}</td>
                    <td>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Type Here Remark..."
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
       <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>

       <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
}

export default Instrument_Check_table;
